export default {
      id: "arrow-top-usage",
      viewBox: "0 0 16 10",
      url: __webpack_public_path__ + "img/icons.ec9c9113.svg#arrow-top",
      toString: function () {
        return this.url;
      }
    }